import { Box, Grid2, Skeleton } from '@mui/material';
import { ReactNode } from 'react';

import MostPopularPlanLabel from '../MostPopularPlanLabel';

export default function PlanContainer({
  children,
  highlighted,
  showPlaceholder,
}: {
  children: ReactNode;
  highlighted?: boolean;
  showPlaceholder?: boolean;
}) {
  return (
    <Grid2 sx={{ display: 'flex' }} size={{ xs: 12, sm: 6, lg: 3 }}>
      {showPlaceholder ? (
        <Skeleton variant="rounded" width={344} height={1000} />
      ) : (
        <Box
          sx={(theme) => ({
            display: 'flex',
            flexDirection: 'column',
            gap: '28px',
            position: 'relative',
            p: {
              xs: '32px 16px 24px 16px',
              sm: '40px 12px 32px 12px',
              lg: '40px 13px 32px 13px',
              xl: '40px 16px 32px 16px',
            },
            borderRadius: '8px',
            border: highlighted
              ? `2px solid ${theme.palette.primary.main}`
              : `1px solid ${theme.palette.grey[200]}`,
            '&:hover': {
              borderColor: theme.palette.primary.light,
            },
          })}
        >
          {children}
          {highlighted && <MostPopularPlanLabel />}
        </Box>
      )}
    </Grid2>
  );
}
